const formatNumber = value => String(Number(value.toFixed(6)));

export const buildPortionDescription = (purchaseValue, portionName) => {
  const value = Number(purchaseValue);
  const normalizedName = portionName?.trim();

  if (!normalizedName || !Number.isFinite(value) || value <= 0) return "";

  const portionAlias = normalizedName.toLocaleLowerCase("pt-BR");
  const weightAliases = ["kg", "quilo", "quilos", "g", "grama", "gramas"];

  if (weightAliases.includes(portionAlias) && value < 1) {
    return `${formatNumber(value * 1000)}g`;
  }

  if (value === 1) return normalizedName;

  const separator = ["g", "grama", "gramas", "ml"].includes(portionAlias)
    ? ""
    : " ";

  return `${formatNumber(value)}${separator}${normalizedName}`;
};
